<template>
  <div class="mt-2">
    <v-autocomplete
      class="pesquisa-autocomplete titulo-label"
      v-model="model"
      :items="grupos"
      item-text="nome"
      item-value="idExterno"
      :filter="filtrarGrupos"
      :loading="carregandoGrupos"
      label="Grupos"
      hint="selecione um grupo para ver seus usuários"
      hide-no-data
      return-object 
      @input="selecionarGrupo($event)"
      :disabled="usuariosCarregados == false"
      >
    </v-autocomplete>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { receber } from "../../../mixins/RequisicaoMixin";
import { headersPadrao } from "../../../mixins/HeadersMixin";
import { usuarios } from "../../../mixins/usuarios.js";

export default {
  props: {
    consulta: {
      default: null
    }, 
    assinaturaDeEmail: {
      type: Object 
    }
  },
  data: () => ({
    textoDeGrupos: "Click para carregar mais grupos",
    botaoCarregarGrupos: false,
    model: null,
    grupos: [],
    carregandoGrupos: false,
    quantidade: 3,
    tokenPaginacao: "",
    //Retirar quando vier a requisição para buscar os usuarios do grupo
    usuarios: [...usuarios()]
  }),
  computed: {
    ...mapState(["barraDeProgresso", "listaUsuarios", "usuariosCarregados"])
  },
  methods: {
    ...mapActions([
      "listaUsuariosDoGrupoNoComponente", 
      "fecharListaDeUsuarios",
      "ativarBarraDeProgresso",
      "paginarUsuarios",
      "carregouUsuarios",
    ]),
    async carregarGrupos(){
      if(this.tokenPaginacao !== null){
        this.botaoCarregarGrupos = true;
        const clienteId = JSON.parse(localStorage.getItem("usuarioLogado")).cliente;
        const urlParaBuscarGrupos = `/api/v1/clientes/${clienteId}/grupos?quantidade=${this.quantidade}&pagina=${this.tokenPaginacao}`;
        await this.requisicaoParaGrupos(urlParaBuscarGrupos);
      }
      this.botaoCarregarGrupos = false;
    },
    async buscarGrupos(){
      this.carregandoGrupos = true;
      var idDoCliente = JSON.parse(localStorage.getItem("usuarioLogado")).cliente;
      var url = `api/v1/multisign/busca?tipo=grupos&cliente=${idDoCliente}&organizacoes=&grupos=`;
      await this.requisicaoParaGrupos(url);
    },
    async requisicaoParaGrupos(url){
      await receber(url, headersPadrao())
      .then((resposta) => {
        const gruposOrdenados = resposta.lista.sort(this.ordernarGrupoPorNome);
        this.grupos.push(...gruposOrdenados);
        if(resposta.tokenPaginacao !== null) {
          this.tokenPaginacao = resposta.tokenPaginacao;
          this.carregandoGrupos = false;
          return;
        }
        this.tokenPaginacao = null;
        this.textoDeGrupos = "Não ha mais grupos";
        this.botaoCarregarGrupos = false;
        this.carregandoGrupos = false;
      }).catch((error) => {
        console.error(error);
        this.tokenPaginacao = null;
        this.$store.commit("erro", "Erro ao buscar grupos. Verifique se as configurações para este cliente foram realizadas corretamente.")
      }).finally(() => {
        this.carregandoGrupos = false;
        this.botaoCarregarGrupos = false;
      })
      return;
    },
    async selecionarGrupo(grupo){
      if(grupo != undefined){
        this.carregouUsuarios(false);
      }
      this.limparListaDeUsuarios([]);
      const usuario = {path: "/grupo", id:`${grupo.idExterno}`, nome: grupo.nome, tipo: "grupo"};
      this.$store.commit("adicionarOrganizacaoOuGrupo", usuario);
      await this.buscarUsuarios(grupo.idExterno);
      return grupo;
    },
    async buscarUsuarios(idDoGrupo){
      this.fecharListaDeUsuarios({
        status: true,
        mensagem: ""
      });
      this.ativarBarraDeProgresso(true);
      const clienteId = JSON.parse(localStorage.getItem("usuarioLogado")).cliente;
      const urlUsuarios = `/api/v1/multisign/busca?tipo=&cliente=${clienteId}&grupo=${idDoGrupo}&organizacao=&quantidade=9`;
      await receber(urlUsuarios,  headersPadrao())
      .then((resposta) => {
        const existeGrupoSemMembro = this.grupoSemMembros(resposta);
        if(existeGrupoSemMembro) return [];
        const listaDeUsuarios = this.addUsuariosEmLista(resposta.lista);
        this.paginarUsuarios({
          grupoId: idDoGrupo,
          tokenPaginacao: resposta.tokenPaginacao
        });
        this.listaUsuariosDoGrupoNoComponente(listaDeUsuarios);
        
      }).catch((error) => console.error(error))
      .finally(() => {
        this.ativarBarraDeProgresso(false);
        this.carregouUsuarios(true);
      })
    },
    grupoSemMembros(membros){
      if(membros.lista.length == 0 && membros.tokenPaginacao == null){
        this.fecharListaDeUsuarios({
          status: false,
          mensagem: "Não existe usuários neste grupo"});
        this.ativarBarraDeProgresso(false);
        return true;
      }
      return false;
    },
    addUsuariosEmLista(usuariosGrupo){
      const listaUsuarios = [];
      usuariosGrupo.map(usuario => {
        listaUsuarios.push(usuario.email)
      });
      return listaUsuarios;
    },
    limparListaDeUsuarios(usuarios){
      if(usuarios.length == 0){
        this.listaUsuariosDoGrupoNoComponente([]);
      }
    },
    filtrarGrupos(item, filtro) {
      const pesquisa = item.nome.toLowerCase();
      const searchText = filtro.toLowerCase();
      return pesquisa.indexOf(searchText) > -1;
    },
    ordernarGrupoPorNome(grupoA, grupoB){
      if (grupoA.nome.toLowerCase() > grupoB.nome.toLowerCase()) return 1;
      if (grupoA.nome.toLowerCase() < grupoB.nome.toLowerCase()) return -1;
      return 0;
    }
  },
  created(){
    this.buscarGrupos()
  }
};
</script>

<style lang="css" scoped>
.pesquisa-autocomplete {
  padding: 0.5rem 1rem 0.3rem 1rem;
}
.titulo-label {
  font-weight: normal !important;
}
</style>